import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';

const ParentIDSearchBar = ({ parentIdSetter }) => {
  const handleParentSearch = () => {
    parentIdSetter(document.getElementById('parentSearchId').value);
  };

  const queryParams = new URLSearchParams(window.location.search);

  const handleKeyDown = e => {
    if (e.key === 'Enter') handleParentSearch();
  };

  return (
    <FormControl sx={{}} variant='outlined'>
      <InputLabel htmlFor='parentSearchId'>Parent Email</InputLabel>
      <OutlinedInput
        type='text'
        startAdornment={
          <InputAdornment position='start'>
            <PermIdentityIcon onClick={handleParentSearch} />
          </InputAdornment>
        }
        label='Parent Email'
        id='parentSearchId'
        onKeyDown={handleKeyDown}
        inputProps={{ 'data-cy': 'id-search-textfield' }}
        defaultValue={queryParams?.get('id')}
        inputRef={input => input && input.focus()}
      />
    </FormControl>
  );
};

export default ParentIDSearchBar;
